<template>
    <div>
        <div class="main_content">
            <div class="bankList_list">
                <div class="cards">
                    <div class="cards_header">
                        <div class="left_txt">
                            <span>{{ $t('bankset.WithdrawalAccount') }}</span>
                            <span>({{ list.length }}/5)</span>
                            <img src="@/assets/withdraw/icon_refresh.png" mode="aspectFit" @click.stop="getBankList" />
                        </div>
                        <div class="eyes" @click.stop="isShowStar = !isShowStar">
                            <img v-if="!isShowStar" src="@/assets/withdraw/icon_eyes.png" mode="aspectFit" />
                            <img v-else src="@/assets/withdraw/icon_eyesAct.png" mode="aspectFit" />
                        </div>
                    </div>
                    <div v-if="list.length">
                        <div class="cards_items" :class="{ 'act': selBank.id == item.id }" v-for="(item, index) in list"
                            :key="index">
                            <img src="@/assets/withdraw/icon_card.png" />
                            <div class="bankInput_txt">
                                <div>{{ item.bankType }}({{ item.bankTypeName }})</div>
                                <div v-if="isShowStar" class="info">
                                    <span >{{ item.customerName }}</span>
                                    <i class="iconfont icon-fuzhiwenjian" @click.stop="onCopy(item.customerName)"></i>
                                </div>
                                <div v-else>{{ item.starAccount }}</div>
                            </div>
                            <div class="sel_btn" @click.stop="setDefaultBank(item)">{{ $t('Withdraw.SetDefault') }}</div>
                            <i class="chose iconfont icon-xuanze"></i>
                        </div>
                    </div>
                    <div v-else class="empty">
                        <img src="@/assets/common/empty.png" mode="heightFix" />
                    </div>
                </div>
            </div>
            <div v-if="list.length < 5" class="manage-bottom">
                <div class="manage-item" @click.stop="onShowFormPopup('DebitCard')">
                    <div class="label">
                        <img src="@/assets/withdraw/icon_pay.png" mode="aspectFit" />
                        <div>Debit Card</div>
                    </div>
                    <div class="add">{{ $t('Withdraw.Add') }}</div>
                </div>
                <div class="manage-item" @click.stop="onShowFormPopup('CLABE')">
                    <div class="label">
                        <img src="@/assets/withdraw/icon_CNPJ.png" mode="aspectFit" />
                        <div>CLABE</div>
                    </div>
                    <div class="add">{{ $t('Withdraw.Add') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBankMexico } from '@/api/withdraw'
export default {
    name: 'bankSetMexico',
    data() {
        return {
            selBank: {},
            list: [],
            pageSize: 10,
            pageNo: 1,
            pages: 0,
            isShowStar: false,

            isShowLoadingPopup: false,
            LoadingNum: 0,

            isShowBanksetPopup: false,
            isShowBanksetPopupCNPJ: false,

            formPopupType: ''
        }
    },
    created() { },
    methods: {
        close() {
            this.$emit('close')
        },
        open() {
            this.getBankList()
        },
        getBankList() {
            getBankMexico({}, {
                custom: {
                    toast: false
                }
            }).then(res => {
                if (res.code) return
                const D = res?.result
                if (D && D.length) {
                    D.forEach(x => {
                        let lastFour = ''
                        lastFour = x.customerName.slice(-4)
                        x.starAccount = '****' + lastFour
                        if (x.customerType === 'DebitCard') {
                            x.bankTypeName = 'Debit Card'
                        }
                        if (x.customerType === 'CLABE') {
                            x.bankTypeName = 'CLABE'
                        }
                    })
                    this.list = D
                    const BankItem = this.$store.getters.bankItem
                    if (BankItem) {
                        this.selBank = JSON.parse(decodeURIComponent(BankItem))
                    } else {
                        this.selBank = D[0]
                    }
                }
            })
        },
        setDefaultBank(item) {
            this.selBank = item
            const BankItem = encodeURIComponent(JSON.stringify(item))
            this.$store.dispatch('user/setBankItem', BankItem)
        },
        onShowFormPopup(type) {
            this.formPopupType = type
            this.$emit('onShowPopup', 'withdrawPwdPopup')
            // this.$refs.withdrawPwdPopup.open()
        },
        WithDrawSucc() {
            if (this.formPopupType === 'DebitCard') {
                this.$emit('onShowPopup', 'banksetPopupDebit')
                // this.$refs.banksetPopupDebit.open()
            } else if (this.formPopupType === 'CLABE') {
                // this.$refs.banksetPopupCLABE.open()
                this.$emit('onShowPopup', 'banksetPopupCLABE')
            }
        },
        setBankSucc() {
            this.getBankList()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.main_content {
    overflow: auto;

    .bankList_list {
        width: 100%;
        overflow: auto hidden;
        padding-bottom: 1px;
        padding-top: .24rem;

        .cards {
            margin: 0 .24rem 0;
            border-radius: .18rem;
            background: var(--theme-popup-panel-bg);
            box-shadow: inset 8px 8px 30px 0px rgba(255,255,255,0.2), inset -8px -8px 30px 0px rgba(255,255,255,0.2);
            padding-bottom: 1px;

            .cards_header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: .2rem .28rem;

                .left_txt {
                    margin-bottom: .12rem;

                    &>span {
                        color: var(--theme-bright-text);
                        font-size: .23rem;
                        margin-right: .1rem;
                    }

                    &>img {
                        width: .36rem;
                        height: .36rem;
                        vertical-align: middle;
                    }
                }

                .eyes {
                    font-size: .32rem;
                    color: $font-iconfont-color;

                    &>img {
                        width: .4rem;
                        height: .4rem;
                        vertical-align: middle;
                    }
                }
            }

            .cards_items {
                height: 100%;
                // background-color: #D47691;
                border: .01rem solid var(--theme-input-border);
                position: relative;
                display: flex;
                align-items: center;
                border-radius: .12rem;
                margin: 0 .28rem;
                margin-bottom: .24rem;
                color: var(--theme-bright-text);
                padding: .06rem .1rem;

                &.act {
                    border: .01rem solid var(--theme-input-focus-border);

                    .chose {
                        display: block;
                    }

                    .sel_btn {
                        display: none;
                    }
                }

                .chose {
                    width: .32rem;
                    height: .4rem;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    color: var(--theme-input-focus-border);
                    border-bottom-right-radius: .1rem;
                    overflow: hidden;
                    font-size: .32rem;
                    display: none;

                    &.img {
                        border: 0;
                    }
                }

                &>img {
                    width: .7rem;
                    height: .7rem;
                    margin-right: .1rem;
                }

                .bankInput_txt {
                    font-size: .2rem;

                    &>view:first-child {
                        font-size: .26rem;
                    }

                    .info {
                        display: flex;
                        align-items: center;

                        .iconfont {
                            font-size: .2rem;
                            margin-left: .12rem;
                            color: var(--theme-soft-text);
                            vertical-align: middle;
                        }
                    }
                }

                .sel_btn {
                    position: absolute;
                    color: var(--theme-bright-text);
                    right: 0;
                    width: 2rem;
                    top: 0;
                    line-height: .24rem;
                    font-size: .22rem;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    text-align: right;
                    padding-right: .28rem;
                    cursor: pointer;
                }
            }

            .empty {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: .42rem;

                &>img {
                    height: 2.88rem;
                }
            }
        }
    }

    .manage-bottom {
        margin: .22rem;
        padding: .22rem;
        padding-bottom: .04rem;
        box-sizing: border-box;
        border-radius: .24rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        box-shadow: inset 8px 8px 30px 0px rgba(255,255,255,0.2), inset -8px -8px 30px 0px rgba(255,255,255,0.2);
        background: var(--theme-popup-panel-bg);

        .manage-item {
            border: .01rem solid var(--theme-input-border);
            border-radius: .2rem;
            padding: .24rem .2rem;
            margin-bottom: .2rem;
            width: calc(50% - .1rem);
            background-image:
                url(@/assets/withdraw/bg-pix2.png),
                linear-gradient(180deg, rgba(var(--theme-input-focus-border-rgb), .16) 0%, rgba(var(--theme-input-focus-border-rgb), 0) 70%),
                var(--theme-popup-box-bg);
            background-size: 1.36rem 1.36rem, 100% 100%, 100% 100%;
            background-repeat: no-repeat;
            background-position: right bottom;
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, .08), var(--theme-popup-box-shadow);

            &:last-child {
                background-image:
                    url(@/assets/withdraw/bg-cnpj.png),
                    linear-gradient(180deg, rgba(var(--theme-input-focus-border-rgb), .16) 0%, rgba(var(--theme-input-focus-border-rgb), 0) 70%),
                    var(--theme-popup-box-bg);
            }

            .label {
                display: flex;
                align-items: center;
                color: var(--theme-bright-text);
                font-size: .26rem;
                margin-bottom: .6rem;

                &>img {
                    width: .58rem;
                    height: .58rem;
                    vertical-align: middle;
                    margin-right: .2rem;
                }
            }

            .add {
                 color: var(--theme-bright-text);font-size: .22rem;
                padding-right: .2rem;
                position: relative;
                cursor: pointer;
                width: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                &:after {
                    content: '';
                    display: inline-block;
                    width: .12rem;
                    height: .12rem;
                    border-top: .01rem solid var(--theme-soft-text);
                    border-right: .01rem solid var(--theme-soft-text);
                    transform: rotate(45deg);
                    margin-left: .12rem;
                }
            }
        }
    }
}
</style>
